/* eslint-disable @typescript-eslint/no-explicit-any */
import { modelOptions, post, prop, Severity } from "@typegoose/typegoose";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";

const SCHEMA_KEY = "LoggerDownlinkResponse" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<LoggerDownlinkResponse>>(...addSchemaKeyHook(SCHEMA_KEY))
export class LoggerDownlinkResponse extends SchemaBase<LoggerDownlinkResponse> {
    static readonly schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => String, required: false })
    public error?: string;

    @prop({ type: () => Number, required: false })
    public statusCode?: number;

    @prop({ type: () => Object, required: false, allowMixed: Severity.ALLOW })
    public data?: Record<string, any>;

    static getters = {} as const satisfies Record<string, (self: LoggerDownlinkResponse) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<LoggerDownlinkResponse>) {
        super(properties);
        Object.assign(this, properties);
    }
}
